import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListarPersonasPage from "./gestionar-persona/listar-personas";
import PersonaPage from "./gestionar-persona/persona";
import ListarPersonalTransportarPage from "./gestionar-personal-transportar/listar-personal-transportar";
import PersonalTransportarPage from "./gestionar-personal-transportar/personal-transportar";
import ListarRiesgoPage from "./gestionar-riesgo/listar-riesgo";
import RiesgoPage from "./gestionar-riesgo/riesgo";
import ListarRutaPage from "./gestionar-ruta/listar-ruta";
import RutaPage from "./gestionar-ruta/ruta";
import ListarTurnoPage from "./gestionar-turno/listar-turno";
import TurnoPage from "./gestionar-turno/turno";
import ListarEstadoViajePage from "./gestionar-estado-viaje/listar-estado-viaje";
import EstadoViajePage from "./gestionar-estado-viaje/estado-viaje";


const RouterAdministracion = () => {
  // console.log('RouterAdministracion');
  const { path } = useRouteMatch();
  // console.log(path);
  return (
    // <LayoutUsuario>
    <Switch>
      {/* <Route exact path={`${path}`}>
        <DashboardScreen />
      </Route> */}

      <Route path={`${path}/listar-personal-transportar`}>
        <ListarPersonalTransportarPage />
      </Route>
      <Route path={`${path}/personal-transportar`}>
        <PersonalTransportarPage />
      </Route>

      <Route path={`${path}/listar-ruta`}>
        <ListarRutaPage />
      </Route>
      <Route path={`${path}/ruta`}>
        <RutaPage />
      </Route>

      <Route path={`${path}/listar-personas`}>
        <ListarPersonasPage />
      </Route>
      <Route path={`${path}/persona`}>
        <PersonaPage />
      </Route>

      <Route path={`${path}/listar-riesgo`}>
        <ListarRiesgoPage />
      </Route>
      <Route path={`${path}/riesgo`}>
        <RiesgoPage />
      </Route>

      <Route path={`${path}/listar-turno`}>
        <ListarTurnoPage />
      </Route>
      <Route path={`${path}/turno`}>
        <TurnoPage />
      </Route>

      <Route path={`${path}/listar-estado-viaje`}>
        <ListarEstadoViajePage />
      </Route>
      <Route path={`${path}/estado-viaje`}>
        <EstadoViajePage />
      </Route>
      {/*<Route path={`${path}/usuario-web`}>
          <UsuarioWeb />
        </Route> */}

    </Switch>
    // </LayoutUsuario>
  );
};

export default RouterAdministracion;
